export interface GeneratorGeneratorSchema {
  name: string;
}
